// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".navigation-container:after,.navigation-container:before{position:absolute;display:block;content:\"\";height:1px;width:100%;background:#000;z-index:30}.blue-rect{background:rgba(13,73,225,.9);color:#fff}.current-width{width:25px;display:inline-block}@media only screen and (max-width:768px){.current-width{width:15px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
